import React from 'react';
import { Trans } from 'react-i18next';

import { connectStore } from 'middleware/connect';
import { setData } from 'middleware/job-offer-storage';

import { Button } from 'components/buttons';
import { FormGroup, InputControl, AutosuggestSelect } from 'components/controls';
import { Settings, dispatchToProps, stateToProps } from './payment-invoice-info.setting';
import { InvoiceAddressList, InvoiceAddressListItem } from './invoice-address-list';

import { AddressDto } from 'rest/address/address.dto';
import { UserAddressDto } from 'rest/address-dto/address';
import { CompanyDto } from 'rest/companies/companies.dto';

@connectStore(stateToProps, dispatchToProps, true)
export class PaymentInvoiceInfo extends Settings {

  componentDidMount () {
    this.loadSavedData();
  }

  loadSavedData = () => {
    const { company: { name, address, invoiceAddress } } = this.props;

    this.setState({
      name,
      ...(invoiceAddress || address)
    });
  };

  goToEditableState = () => {
    this.props.handleEditableState();
  };

  handleCancel = () => {
    this.loadSavedData();
    this.props.handleEditableState();
  };

  suggestCountry (value) {
    const query: AddressDto = new AddressDto();
    query.city = '';
    query.street = '';
    query.country = value;
    this.props.searchSuggestedAddress('country', query);
  }

  suggestStreet (value) {
    const query: AddressDto = new AddressDto(this.state);
    query.street = value;
    this.props.searchSuggestedAddress('street', query);
  }

  suggestCity (value) {
    const query: AddressDto = new AddressDto(this.state);
    query.street = '';
    query.city = value;
    this.props.searchSuggestedAddress('city', query);
  }

  saveDraft = e => {
    if (e) e.preventDefault();

    const { company } = this.props;
    const { name } = this.state;

    const companyData: CompanyDto = {
      ...company,
      invoiceAddress: {
        name,
        ...new UserAddressDto(this.state)
      }
    };

    setData('ej_company_info', companyData);
    this.props.handleEditableState(companyData);
  };

  render () {
    const { disabled, t, address, editable, currentUser: { email } } = this.props;
    const { name, city, country, street, streetNumber, zipCode } = this.state;

    return (
      <>
        {editable && !disabled
          ? <form
            className="company-info-form"
            onSubmit={this.saveDraft}>
            <FormGroup className="half-width">
              <InputControl
                required
                name="name"
                value={name}
                label={t('portal.guest.recruiter.job-offer.payment.invoice-details.company-name.label')}
                placeholder={t('portal.guest.recruiter.job-offer.payment.' +
                  'invoice-details.company-name.placeholder')}
                change={name => this.setState({ name })}
                type="text"/>
            </FormGroup>
            <div className="form-group-row">
              <FormGroup className="half-width">
                <AutosuggestSelect
                  required
                  label={t('portal.guest.recruiter.job-offer.payment.invoice-details.country.label')}
                  items={address.country}
                  placeholder={t('portal.guest.recruiter.job-offer.payment' +
                    '.invoice-details.country.placeholder')}
                  defaultValue={country}
                  change={value => this.setState({ country: value })}
                  search={value => this.suggestCountry(value)}/>
              </FormGroup>
              <FormGroup className="half-width">
                <AutosuggestSelect
                  label={t('portal.guest.recruiter.job-offer.payment.invoice-details.city.label')}
                  required
                  items={address.city}
                  defaultValue={city}
                  change={value => this.setState({ city: value })}
                  search={value => this.suggestCity(value)}
                  placeholder={t('portal.guest.recruiter.job-offer.payment' +
                    '.invoice-details.city.placeholder')}/>
              </FormGroup>
            </div>
            <FormGroup className="half-width">
              <InputControl
                required
                label={t('portal.guest.recruiter.job-offer.payment.invoice-details.zip.label')}
                value={zipCode}
                placeholder={t('portal.guest.recruiter.job-offer.payment.invoice-details.zip.placeholder')}
                errorText={t('portal.guest.recruiter.job-offer.payment.invoice-details.zip.error')}
                change={zipCode => this.setState({ zipCode })}
                type="text"/>
            </FormGroup>
            <div className="form-group-row">
              <FormGroup className="half-width">
                <AutosuggestSelect
                  required
                  defaultValue={street}
                  items={address.street}
                  label={t('portal.guest.recruiter.job-offer.payment.invoice-details.street.label')}
                  placeholder={t('portal.guest.recruiter.job-offer.payment' +
                    '.invoice-details.street.placeholder')}
                  change={value => this.setState({ street: value })}
                  search={value => this.suggestStreet(value)}/>
              </FormGroup>
              <FormGroup className="half-width billing-number">
                <InputControl
                  required
                  label={t('portal.guest.recruiter.job-offer.payment' +
                    '.invoice-details.building-number.label')}
                  value={streetNumber}
                  placeholder={t('portal.guest.recruiter.job-offer.payment' +
                    '.invoice-details.building-number.placeholder')}
                  errorText={t('portal.guest.recruiter.job-offer.payment' +
                    '.invoice-details.building-number.error')}
                  change={streetNumber => this.setState({ streetNumber })}
                  type="text"/>
              </FormGroup>
            </div>

            <div className="payment-action">
              <Button
                large
                className="btn accent"
                type="submit">
                <Trans i18nKey="portal.guest.recruiter.job-offer.payment.invoice-details.buttons.confirm">
                  Confirm
                </Trans>
              </Button>
              <Button
                type="button"
                className="btn accent grey"
                onClick={this.handleCancel}>
                <Trans i18nKey="portal.guest.recruiter.job-offer.payment.invoice-details.buttons.cancel">
                  Cancel
                </Trans>
              </Button>
            </div>
          </form>
          : <div className="company-info-default">
            <h5 className="company-info-default-title m-0">Invoice address</h5>

            <InvoiceAddressList>
              <InvoiceAddressListItem title="Hotel name:" i18nKey="hotel">
                <span className="invoice-address-list-info">&nbsp;{name}</span>
              </InvoiceAddressListItem>
              <InvoiceAddressListItem title="Address:" i18nKey="address">
                <span className="invoice-address-list-info">&nbsp;{country},</span>
                <span className="invoice-address-list-info">&nbsp;{city},</span>
                <span className="invoice-address-list-info">&nbsp;{zipCode},</span>
                <span className="invoice-address-list-info">&nbsp;{street},</span>
                <span className="invoice-address-list-info">&nbsp;{streetNumber}</span>
              </InvoiceAddressListItem>
              <InvoiceAddressListItem title="Email:" i18nKey="email">
                <span className="invoice-address-list-info">&nbsp;{email}</span>
              </InvoiceAddressListItem>
            </InvoiceAddressList>

            <Button
              type="button"
              className="btn accent outlined"
              onClick={this.goToEditableState}>
              <Trans i18nKey="portal.guest.recruiter.job-offer.payment.invoice-details.buttons.change">
                Change Invoice Address
              </Trans>
            </Button>
          </div>
        }
      </>
    );
  }

}
